import { getData } from '../../../get-table'
import { HttpService } from '../../../http.service'
// import { ReportPayEmployee } from '../../types'

const http = new HttpService()

export async function getEmployerRecords(companyId: string): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_employer_records'],
    fields: [
      'employer_records.id as id',
      "CONCAT(employer_records.code,' - ',custom_options.name) as name",
      'employer_records.work_centers'
    ],
    join: [
      "INNER JOIN custom_options ON json_extract_path_text(employer_records.custom_fields::json, 'custom:mxRiskClass')::uuid = custom_options.id"
    ],
    where: [
      `employer_records.company_id = '${companyId}'`,
      'employer_records.is_active = true'
    ]
  })

  return response[0].results
}

export async function generatePayEmployee(
  data: ReportPayEmployee
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export interface ParametersPayEmployee {
  payrolls: string[]
  processes: string[]
  startDate: Date
  endDate: Date
  status: string
  employees: string[]
  concepts: string
  translate: string
}
export interface ReportPayEmployee {
  code: string
  parameters: ParametersPayEmployee
}
